import { RestoreLocationsRequest } from '../../../../../types/underwriting.type';
import { getProductFilteredLocations } from '../../../../../helpers/submissions';
import { SubmissionDetails } from '../../../../../types/submission.type';
import { Location } from '../../../../../types/location.type';
import { restoreLocationsForUW } from '../../../../../services/submission';

export const restoreLocations = async (
    payload: RestoreLocationsRequest,
    productLineType: string,
    sovLocations: Location[],
    submission: SubmissionDetails,
    doUnExcludeLocations?: (unexcludedLocationsParam: number[]) => void
) => {
    const restoreIds: number[] = [];
    const unexcludeIds: number[] = [];
    payload.locationIds.forEach((locId) => {
        if (
            getProductFilteredLocations(productLineType, sovLocations, submission, true).some((pl) => pl.id === locId)
        ) {
            // this location is part of the available list, but excluded, add to unexcludeIds
            unexcludeIds.push(locId);
        } else {
            restoreIds.push(locId);
        }
    });
    if (restoreIds.length) {
        payload.locationIds = restoreIds;
        await restoreLocationsForUW(submission.id, payload);
        window.location.reload();
    } else {
        // currently (see above) any restore locations will cause a page refresh which will also restore any excluded so only do this if all are just excluded
        doUnExcludeLocations && doUnExcludeLocations(unexcludeIds);
    }
};
